import "./leftColumn.css";
import { AboutMe } from "../../components/leftColumn/AboutMe/AboutMe";
import { Spotify } from "../../components/leftColumn/Spotify/Spotify";
import { Vrchat } from "../../components/leftColumn/Vrchat/Vrchat";
import { CurrentlyPlaying } from "../../components/leftColumn/Steam/Steam";
import { CountryData } from "../../components/leftColumn/CountryData/CountryData";
import { BlogRedirect } from "../../components/leftColumn/BlogRedirect/BlogRedirect";
import { Wakatime } from "../../components/leftColumn/Wakatime/Wakatime";
import { Anime } from "../../components/leftColumn/Anime/Anime";

export default function LeftColumn() {
  const isPhone = window.innerWidth <= 850;

  return (
    <div className="left-grid">
      <div className="about-me-grid">
        <AboutMe />
      </div>
      <div className="spotify-grid">
        <Spotify />
      </div>
      <div className="vrchat-grid">
        <Vrchat />
      </div>
      <div className="curr-playing-grid">
        <CurrentlyPlaying />
      </div>
      <div className="country-data-grid">
        <CountryData />
      </div>
      {!isPhone && (
        <>
          <div className="letterbox-grid">
            <BlogRedirect />
          </div>
          <div className="wakatime-grid">
            <Wakatime />
          </div>
        </>
      )}
      <div className="anime-grid">
        <Anime />
      </div>
      {isPhone && (
        <div className="phone-left-spacing">
          <Wakatime />
          <BlogRedirect />
        </div>
      )}
    </div>
  );
}
